import create from 'zustand'
import { devtools } from 'zustand/middleware'
import axios from 'axios';
import produce from 'immer';
import Cookies from 'js-cookie'

// "BTCUSDT:1000 ETHUSDT:500", "BTCUSDT:1000 ETHUSDT:500 BTCUSDT:500 ETHUSDT:250"

const useUserSettingStore = create((set, get) => ({
    sizes: [],
    instruments: [],
    targets: [],
    defaultSizes: [1000, 2500, 5000, 10000, 20000, 50000, 100000, 250000, 500000, 800000, 1000000],
    defaultInstruments:['1INCHUSD', 'AAVEUSD', 'ACAUSD', 'ACHUSD','ADAUSD', 'ADXUSD', 'AGLDUSD', 'AIRUSD', 'AKTUSD', 'ALCXUSD', 'ALGOUSD', 'ALICEUSD', 'ALPHAUSD', 'ANKRUSD', 'ANTUSD', 'APEUSD', 'API3USD', 'APTUSD', 'ARBUSD', 'ARPAUSD', 'ASTRUSD', 'ATLASUSD', 'ATOMUSD', 'AUDIOUSD', 'ZAUDUSD', 'AVAXUSD', 'AXSUSD', 'BADGERUSD', 'BALUSD', 'BANDUSD', 'BATUSD', 'BCHUSD', 'BICOUSD', 'BITUSD', 'BLURUSD', 'BLZUSD', 'BNCUSD', 'BNTUSD', 'BOBAUSD', 'BONDUSD', 'BRICKUSD', 'BSXUSD', 'BTTUSD', 'C98USD', 'CELRUSD', 'CFGUSD', 'CHRUSD', 'CHZUSD', 'COMPUSD', 'COTIUSD', 'CQTUSD', 'CRVUSD', 'CSMUSD', 'CTSIUSD', 'CVCUSD', 'CVXUSD', 'DAIUSD', 'DASHUSD', 'DENTUSD', 'DOTUSD', 'DYDXUSD', 'EGLDUSD', 'ENJUSD', 'ENSUSD', 'EOSUSD', 'ETHWUSD', 'EULUSD', 'EURTUSD', 'EWTUSD', 'FARMUSD', 'FETUSD', 'FIDAUSD', 'FILUSD', 'FISUSD', 'FLOWUSD', 'FLRUSD', 'FORTHUSD', 'FTMUSD', 'FXSUSD', 'GALAUSD', 'GALUSD', 'GARIUSD', 'GHSTUSD', 'GLMRUSD', 'GMTUSD', 'GMXUSD', 'GNOUSD', 'GRTUSD', 'GSTUSD', 'GTCUSD', 'HDXUSD', 'HFTUSD', 'ICPUSD', 'ICXUSD', 'IDEXUSD', 'IMXUSD', 'INJUSD', 'INTRUSD', 'JASMYUSD', 'JUNOUSD', 'KARUSD', 'KAVAUSD', 'KEEPUSD', 'KEYUSD', 'KILTUSD', 'KINTUSD', 'KINUSD', 'KNCUSD', 'KP3RUSD', 'KSMUSD', 'LCXUSD', 'LDOUSD', 'LINKUSD', 'LMWRUSD', 'LPTUSD', 'LRCUSD', 'LSKUSD', 'LUNA2USD', 'LUNAUSD', 'MANAUSD', 'MASKUSD', 'MATICUSD', 'MCUSD', 'MINAUSD', 'MIRUSD', 'MKRUSD', 'MNGOUSD', 'MOONUSD', 'MOVRUSD', 'MSOLUSD', 'MULTIUSD', 'MVUSD', 'MXCUSD', 'NANOUSD', 'NEARUSD', 'NMRUSD', 'NODLUSD', 'NYMUSD','OCEANUSD', 'OGNUSD', 'OMGUSD', 'ORCAUSD', 'OXTUSD', 'OXYUSD', 'PARAUSD', 'PAXGUSD', 'PEPEUSD', 'PERPUSD', 'PHAUSD', 'PLAUSD', 'POLISUSD', 'POLSUSD', 'PONDUSD', 'POWRUSD', 'PSTAKEUSD', 'PYUSDUSD', 'QNTUSD', 'QTUMUSD', 'RADUSD', 'RAREUSD', 'RARIUSD', 'RAYUSD', 'RBCUSD', 'RENUSD', 'REPV2USD', 'REQUSD', 'RLCUSD', 'RNDRUSD', 'ROOKUSD', 'RPLUSD', 'RUNEUSD', 'SAMOUSD', 'SANDUSD', 'SBRUSD', 'SCRTUSD', 'SCUSD', 'SDNUSD', 'SEIUSD', 'SGBUSD', 'SHIBUSD', 'SNXUSD', 'SOLUSD', 'SPELLUSD', 'SRMUSD', 'STEPUSD', 'STGUSD', 'STORJUSD', 'STXUSD', 'SUIUSD', 'SUPERUSD', 'SUSHIUSD', 'SYNUSD', 'TBTCUSD', 'TEERUSD', 'TLMUSD', 'TOKEUSD', 'TRUUSD', 'TRXUSD', 'TUSD', 'TUSDUSD', 'TVKUSD', 'UMAUSD', 'UNFIUSD', 'UNIUSD', 'USDCUSD', 'USTUSD', 'WAVESUSD', 'WAXLUSD', 'WBTCUSD', 'WOOUSD', 'XCNUSD', 'DOGEUSD', 'ETCUSD', 'ETHUSD', 'LTCUSD', 'MLNUSD', 'REPUSD', 'XRTUSD', 'XTZUSD', 'BTCUSD', 'XLMUSD', 'XMRUSD', 'XRPUSD', 'ZECUSD', 'YFIUSD', 'YGGUSD', 'ZEURUSD', 'ZGBPUSD', 'ZRXUSD'],

    fecthUserSettings: async () => {
    
        const token = Cookies.get('token')
        
        try {
            const res = await axios({
                headers: { Authorization: token },
                method: "GET",
                url:"/api/fetch_user_settings",
                timeout : 10000
            })
            const user_sizes = res.data.size
            const user_instruments = res.data.instrument
            const targets = res.data.targets
            set({sizes: user_sizes})
            set({instruments: user_instruments})
            set({targets: targets})
        } catch (err) {
            console.log(err)
        }
    },
    reloadUserSettings: async(user_settings_data) => {
        get().fecthUserSettings()
    },
    setDefaultUserSetting: () => {
        set({sizes: get().defaultSizes})
        set({instruments: get().defaultInstruments})
    }

}))



export  default useUserSettingStore 